import GiftsBlock from './GiftsBlock';

export default GiftsBlock;
